<template>
  <div class="map-service-info">
    <div class="header">
      <div>
        <i
          class="el-icon-back icon"
          @click="backMapServiceList" />
      </div>
      <div>{{ currMode === 'createService' ? '新增' : '编辑' }}地图服务</div>
    </div>
    <div class="service-form-box">
      <el-form
        ref="serviceForm"
        label-width="150px"
        class="public-form-primary"
        :model="serviceForm"
        :rules="rules">
        <el-form-item
          label="服务名称:"
          prop="serviceName">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请输入服务名称"
            v-model="serviceForm.serviceName" />
        </el-form-item>
        <el-form-item
          class="file-center"
          label-width="0"
          prop="capabilityType"
          v-if="currMode === 'createService'">
          <div class="apabilityLabel">
            <span>Capability文件</span>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box wmts-template-tooltip-box">
              <div slot="content">
                此处需要指定WMTS的Capability信息，可以通过两种方式指定：
                <div class="tip-item-box">
                  1）通过服务地址和GetCapability接口指定
                </div>
                <div class="tip-item-box">
                  2）可以把这个文件下载并保存为一个xml文件，通过上传该文件指定
                </div>
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-jieshishuoming" />
              </div> </el-tooltip
            >:
          </div>

          <el-radio-group
            class="radio-primary"
            v-model="serviceForm.capabilityType">
            <el-radio :label="2">通过URL指定</el-radio>
            <el-radio :label="1">通过文件指定</el-radio>
          </el-radio-group>
        </el-form-item>
        <div
          v-if="currMode === 'createService'"
          class="item-box">
          <div class="label-box"></div>
          <div
            v-if="serviceForm.capabilityType === 1"
            class="common-input-box">
            <el-input
              size="small"
              class="input-primary"
              v-model="xmlFileInfo.fileName"
              readonly />
          </div>
          <div
            class="common-input-box"
            v-if="serviceForm.capabilityType === 2">
            <el-input
              size="small"
              class="input-primary"
              v-model="capabilityUrl" />
          </div>
          <div
            v-if="serviceForm.capabilityType === 1"
            class="common-upload-box">
            <el-upload
              ref="upload"
              :action="action"
              :headers="getHeaders()"
              :data="uploadParams"
              name="FileInfo"
              accept=".xml"
              :show-file-list="false"
              :on-change="handleUploadChange"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :auto-upload="false">
              <div>
                <el-button
                  size="small"
                  type="primary"
                  class="gl8 primary-btn">
                  上传文件
                </el-button>
              </div>
            </el-upload>
          </div>
          <div v-if="serviceForm.capabilityType === 2">
            <el-button
              class="primary-btn gl8"
              type="primary"
              size="small"
              @click="analyzeCapabilityByUrl(2)">
              读取
            </el-button>
          </div>
        </div>
        <el-form-item
          label="图层类型:"
          prop="layerResType">
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              :popper-append-to-body="false"
              v-model="serviceForm.layerResType"
              placeholder="请选择图层类型">
              <el-option
                v-for="item in layerTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <div
          class="item-box"
          prop="layer">
          <div class="side-mark-box"></div>
          <div class="symbol-label-box">
            <div class="symbol-box"></div>
            <div>选取图层:</div>
          </div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              :popper-append-to-body="false"
              v-model="serviceForm.layer"
              @change="handleLayerChange">
              <el-option
                v-for="(item, index) in layerList"
                :key="index"
                :label="item.m_strTitle"
                :value="item.m_strIdentifier" />
            </el-select>
          </div>
        </div>
        <div class="layer-info-box">
          <div class="item-box">
            <div class="label-box disabled">图层样式:</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                :disabled="true"
                v-model="serviceForm.layerStyle" />
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">范围:</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                :disabled="true"
                v-model="serviceForm.layerRange" />
            </div>
          </div>
          <div class="item-box">
            <div class="label-box">
              <div class="label">瓦片URL模板</div>
              <el-tooltip
                :effect="$theme.tooltipKey()"
                placement="top-start"
                popper-class="common-panel-tooltip-box wmts-template-tooltip-box">
                <div slot="content">
                  对于天地图服务，Web端和App端访问的服务需要不同的token，这里要分别设置；如果不同终端类型使用相同资源地址，这里把Web端和App端填写相同的地址模板即可；
                  如果资源服务可以从多个主机上请求，且主机的编号是连续几个数字，则随机的数字用%R%{a,b}
                  来占位
                </div>
                <div class="icon-box urlModel">
                  <icon-svg
                    icon-class="ic-jieshishuoming"
                    class="icon" />
                </div>
              </el-tooltip>
              <div>:</div>
            </div>
            <div class="url-content-box">
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  placeholder="请输入URL"
                  v-model="serviceForm.fmtStr_Web" />
              </div>
              <div
                class="icon-box"
                @click="openAppUrlForm"
                v-if="!isAppUrlVisible">
                <i
                  title="添加APP端URL"
                  class="el-icon-circle-plus-outline" />
              </div>
            </div>
          </div>
          <div
            class="item-box"
            v-if="isAppUrlVisible">
            <div class="label-box">
              <div class="label">瓦片APP端URL模板:</div>
            </div>
            <div class="url-content-box">
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  placeholder="请输入URL"
                  v-model="serviceForm.fmtStr_App" />
              </div>
              <div
                class="icon-box"
                @click="closeAppUrlForm">
                <i
                  title="移除APP端URL"
                  class="el-icon-remove-outline" />
              </div>
            </div>
          </div>
        </div>
        <div class="item-box">
          <div class="side-mark-box"></div>
          <div class="symbol-label-box">
            <div class="symbol-box"></div>
            <div>瓦片集:</div>
          </div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              :popper-append-to-body="false"
              v-model="serviceForm.tileSet"
              @change="handleTileSetChange">
              <el-option
                v-for="(item, index) in tileSetList"
                :key="index"
                :label="item.m_strID"
                :value="item.m_strID" />
            </el-select>
          </div>
        </div>
        <div class="layer-info-box">
          <div class="item-box">
            <div class="label-box">坐标系:</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="serviceForm.crs" />
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">通用比例尺:</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                :disabled="true"
                v-model="serviceForm.wellKnownScale" />
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">空间起点坐标:</div>
            <div class="xy-input-box">
              <div class="label">X：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.startPointX" />
              </div>
            </div>
            <div class="xy-input-box">
              <div class="label">Y：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.startPointY" />
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">空间总体跨度:</div>
            <div class="xy-input-box">
              <div class="label">X：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.spaceExtentX" />
              </div>
            </div>
            <div class="xy-input-box">
              <div class="label">Y：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.spaceExtentY" />
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">顶层瓦片数:</div>
            <div class="xy-input-box">
              <div class="label">X：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.projFlatRootNumX" />
              </div>
            </div>
            <div class="xy-input-box">
              <div class="label">Y：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.projFlatRootNumY" />
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">瓦片像素数:</div>
            <div class="xy-input-box">
              <div class="label">X：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.tilePixelX" />
              </div>
            </div>
            <div class="xy-input-box">
              <div class="label">Y：</div>
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :disabled="true"
                  v-model="serviceForm.tilePixelY" />
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="label-box disabled">LOD列表:</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                :disabled="true"
                v-model="serviceForm.lodDes" />
            </div>
            <div
              class="view-detail-btn-box"
              @click="toggleLodListVisible">
              <div class="icon-box">
                <icon-svg icon-class="ic-chakanxiangqing" />
              </div>
              <div class="title">查看详情</div>
              <div class="icon-box">
                <i
                  v-if="isTableVisible"
                  class="el-icon-caret-top" />
                <i
                  v-else
                  class="el-icon-caret-bottom" />
              </div>
            </div>
          </div>
          <div
            v-if="isTableVisible"
            class="item-box">
            <div class="label-box"></div>
            <div class="publish-table-container">
              <el-table
                class="publish-small-table"
                highlight-selection-row
                :data="lodList"
                height="100%">
                <el-table-column
                  label="LOD"
                  prop="m_strID"
                  width="70" />
                <el-table-column label="比例尺">
                  <template v-slot="{ row }">
                    <div
                      class="text-overflow"
                      :title="row.m_dScaleDeno">
                      {{ row.m_dScaleDeno }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="瓦片块数">
                  <template v-slot="{ row }">
                    <span>
                      {{ `${row.m_vMatrixWH.x}×${row.m_vMatrixWH.x}` }}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/generalMethods'

import {
  createWmtsInFolderService,
  analyzeCapabilityService
} from '@/service/interface'

const BLOB_SIZE = 20 * 1024 * 1024

export default {
  data() {
    return {
      serviceForm: {
        serviceName: '',
        capabilityType: 2,
        layerResType: '',
        layer: '',
        layerStyle: '',
        layerRange: '',
        fmtStr_Web: '',
        fmtStr_App: '',
        tileSet: '',
        crs: '',
        wellKnownScale: '',
        startPointX: '',
        startPointY: '',
        spaceExtentX: '',
        spaceExtentY: '',
        projFlatRootNumX: '',
        projFlatRootNumY: '',
        tilePixelX: '',
        tilePixelY: '',
        lodDes: ''
      },
      rules: {
        serviceName: [
          {
            required: true,
            message: '请输入服务名称',
            trigger: ['change', 'blur']
          }
        ],
        capabilityType: [
          {
            required: true,
            message: '请选择CapabilityType文件指定方式',
            trigger: ['change', 'blur']
          }
        ],
        layerResType: [
          {
            required: true,
            message: '请选择图层类型',
            trigger: ['change', 'blur']
          }
        ],
        layer: [
          {
            required: true,
            message: '请选择图层',
            trigger: ['change', 'blur']
          }
        ]
      },

      capabilityUrl: '',
      isUploadFinish: false,
      action: `${window.serverUrl}/starRiver3D/project/wmtsTemplate/v3/append`,
      uploadParams: {},
      xmlFileInfo: {
        fileName: '',
        fileAddr: ''
      },
      isAppUrlVisible: false,
      capabilityInfo: {},
      isTableVisible: false,

      layerTypeList: [
        // {
        //   label: "地形层",
        //   value: "height",
        // },
        {
          label: '基础影像层',
          value: 'imgpic_img'
        },
        {
          label: '矢量标注叠加层',
          value: 'imgpic_vec'
        }
      ],
      layerList: [],
      tileSetList: [],
      lodList: [
        // {
        //   m_strID:1,
        //   m_dScaleDeno:1,
        //   m_vMatrixWH:{
        //     x:1
        //   }
        // },
      ]
    }
  },
  props: {
    currMode: String,
    updateCurrMode: Function,
    resetSeniorParams: Function,
    currMapServiceInfo: Object
  },
  methods: {
    backMapServiceList() {
      this.resetSeniorParams()
      this.clearServiceForm()
      this.updateCurrMode('serviceList')
    },
    initServiceForm() {
      let {
        capabilityType,
        capabilityAddr,
        CapabilityInfo,
        serviceName,
        layerResType,
        picTransp,
        fmtStr_Web,
        fmtStr_App
      } = this.currMapServiceInfo
      this.getCapabilityInfo(capabilityType, capabilityAddr).then(() => {
        let currCapabilityInfo = JSON.parse(CapabilityInfo)
        this.initLayer(currCapabilityInfo)
        this.initTileSet()

        this.serviceForm.serviceName = serviceName
        this.serviceForm.capabilityType = capabilityType
        if (layerResType === 'height') {
          this.serviceForm.layerResType = 'height'
        } else if (layerResType === 'imgpic_img' && picTransp === 0) {
          this.serviceForm.layerResType = 'imgpic_img'
        } else {
          this.serviceForm.layerResType = 'imgpic_vec'
        }

        this.serviceForm.fmtStr_App = fmtStr_App ? fmtStr_App : fmtStr_Web
      })
    },
    handleLayerChange(layer) {
      let layerInfo = this.layerList.find(el => el.m_strIdentifier === layer)
      if (layerInfo) {
        let { m_lstMatSetLinks } = layerInfo
        let defaultTileSet = m_lstMatSetLinks[0].m_strTileMatSetID
        this.serviceForm.tileSet = defaultTileSet
        this.serviceForm.layerStyle = layerInfo.m_strDefStyle
        // prettier-ignore
        this.serviceForm.layerRange = this.getLayerRange(layerInfo.m_lstVVBB);
        // prettier-ignore
        this.serviceForm.fmtStr_Web = this.getWebResUrl();
      }
    },
    handleTileSetChange(tileSet) {
      // prettier-ignore
      this.serviceForm.fmtStr_Web = this.getWebResUrl();

      let tileSetInfo = this.tileSetList.find(el => el.m_strID === tileSet)
      if (tileSetInfo) {
        this.serviceForm.crs = tileSetInfo.m_strCRS
        // prettier-ignore
        this.serviceForm.wellKnownScale = tileSetInfo.m_strWellKnownScaleSet;

        this.serviceForm.spaceExtentX = tileSetInfo.m_vAABB.x
        this.serviceForm.spaceExtentY = tileSetInfo.m_vAABB.y
        let topLevelTileSetInfo = tileSetInfo.m_lstTileMatrixSets[0]

        let { m_vTLCorner, m_vMatrixWH, m_vTileWH } = topLevelTileSetInfo
        this.serviceForm.startPointX = m_vTLCorner.x
        this.serviceForm.startPointY = m_vTLCorner.y
        this.serviceForm.projFlatRootNumX = m_vMatrixWH.x
        this.serviceForm.projFlatRootNumY = m_vMatrixWH.y
        this.serviceForm.tilePixelX = m_vTileWH.x
        this.serviceForm.tilePixelY = m_vTileWH.y

        let lodList = tileSetInfo.m_lstTileMatrixSets
        // prettier-ignore
        let lodDes = `共有${lodList.length}级瓦片【${lodList[0].m_strID},${lodList.length - 1}】`;
        this.serviceForm.lodDes = lodDes
        this.lodList = lodList
      }
    },
    openAppUrlForm() {},
    closeAppUrlForm() {},
    analyzeCapabilityByUrl(capabilityType) {
      if (this.serviceForm.capabilityAddr) {
        this.$message.warning('请先输入URL')
        return
      }

      let capabilityAddr = this.serviceForm.capabilityAddr
      this.analyzeCapability(capabilityType, capabilityAddr)
    },
    handleUploadChange(file) {
      if (this.isUploadFinish) {
        this.isUploadFinish = false
        return
      }

      let count = file.size / BLOB_SIZE
      let params = {
        fileName: file.name,
        fileSize: file.size,
        blobCount: Math.ceil(count),
        blobSize: BLOB_SIZE
      }
      createWmtsInFolderService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data

          this.xmlFileInfo.fileAddr = data.savePath

          this.$set(this.uploadParams, 'FileDataId', data.fileDataId)
          this.$set(this.uploadParams, 'Key', data.fileKey)
          this.$set(this.uploadParams, 'Index', 0)

          this.$refs.upload.submit()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleUploadSuccess(response, file) {
      if (response.isSuccess) {
        this.isUploadFinish = true

        this.xmlFileInfo.fileName = file.name

        let capabilityType = 1
        let capabilityAddr = this.xmlFileInfo.fileAddr
        this.analyzeCapability(capabilityType, capabilityAddr).then(() => {
          if (capabilityType === 1) {
            this.uploadParams = {}
          }
        })
      } else {
        this.isUploadFinish = true
        this.xmlFileInfo = {}
        this.uploadParams = {}

        this.$message.error(response.errMsg)
      }
    },
    handleUploadError(error) {
      console.log(error, '失败')

      this.isUploadFinish = true
      this.xmlFileInfo = {}
      this.uploadParams = {}
      this.$message.error('文件上传失败')
    },
    analyzeCapability(capabilityType, capabilityAddr) {
      return new Promise(resolve => {
        this.getCapabilityInfo(capabilityType, capabilityAddr).then(() => {
          this.initLayer()
          this.initTileSet()

          resolve()
        })
      })
    },
    initLayer(currCapabilityInfo) {
      let { m_lstWMTSLayer } = this.capabilityInfo
      this.layerList = m_lstWMTSLayer

      let currLayerInfo = null
      if (currCapabilityInfo) {
        currLayerInfo = currCapabilityInfo.m_lstWMTSLayer[0]
      } else {
        currLayerInfo = m_lstWMTSLayer[0]
      }

      let currTileSet = null
      if (currCapabilityInfo) {
        let { m_lstTileMatrixSet } = currCapabilityInfo
        currTileSet = m_lstTileMatrixSet[0].m_strID
      } else {
        let { m_lstMatSetLinks } = currLayerInfo
        currTileSet = m_lstMatSetLinks[0].m_strTileMatSetID
      }

      this.serviceForm.layer = currLayerInfo.m_strIdentifier
      this.serviceForm.tileSet = currTileSet
      this.serviceForm.layerStyle = currLayerInfo.m_strDefStyle
      // prettier-ignore
      this.serviceForm.layerRange = this.getLayerRange(currLayerInfo.m_lstVVBB);
      // prettier-ignore
      this.serviceForm.fmtStr_Web = this.getWebResUrl();
    },
    initTileSet() {
      let { m_lstTileMatrixSet } = this.capabilityInfo
      this.tileSetList = m_lstTileMatrixSet

      let defaultTileSetInfo = m_lstTileMatrixSet.find(
        el => el.m_strID === this.serviceForm.tileSet
      )
      this.serviceForm.tileSet = defaultTileSetInfo.m_strID
      this.serviceForm.crs = defaultTileSetInfo.m_strCRS
      // prettier-ignore
      this.serviceForm.wellKnownScale = defaultTileSetInfo.m_strWellKnownScaleSet;

      this.serviceForm.spaceExtentX = defaultTileSetInfo.m_vAABB.x
      this.serviceForm.spaceExtentY = defaultTileSetInfo.m_vAABB.y
      let topLevelTileSetInfo = defaultTileSetInfo.m_lstTileMatrixSets[0]

      let { m_vTLCorner, m_vMatrixWH, m_vTileWH } = topLevelTileSetInfo
      this.serviceForm.startPointX = m_vTLCorner.x
      this.serviceForm.startPointY = m_vTLCorner.y
      this.serviceForm.projFlatRootNumX = m_vMatrixWH.x
      this.serviceForm.projFlatRootNumY = m_vMatrixWH.y
      this.serviceForm.tilePixelX = m_vTileWH.x
      this.serviceForm.tilePixelY = m_vTileWH.y

      let lodList = defaultTileSetInfo.m_lstTileMatrixSets
      // prettier-ignore
      let lodDes = `共有${lodList.length}级瓦片【${lodList[0].m_strID},${lodList.length - 1}】`;
      this.serviceForm.lodDes = lodDes
      this.lodList = lodList
    },
    getServiceParams() {
      let {
        serviceName,
        fmtStr_Web,
        fmtStr_App,
        layerResType,
        capabilityType,
        layer,
        tileSet
      } = this.serviceForm

      let params = {
        serviceName,
        fmtStr_Web,
        fmtStr_App: fmtStr_App ? fmtStr_App : fmtStr_Web,
        layerResType
      }

      // prettier-ignore
      let m_lstTileMatrixSet = this.tileSetList.filter(el => el.m_strID === tileSet);
      // prettier-ignore
      let m_lstWMTSLayer = this.layerList.filter(el => el.m_strIdentifier === layer);
      let capabilityInfo = { m_lstTileMatrixSet, m_lstWMTSLayer }
      params.capabilityInfo = capabilityInfo

      if (layerResType === 'height') {
        params.layerResType = 'height'
      } else if (layerResType === 'imgpic_img') {
        params.layerResType = 'imgpic'
        params.picTransp = 0
      } else {
        params.layerResType = 'imgpic'
        params.picTransp = 1
      }

      if (this.currMode === 'createService') {
        params.capabilityType = capabilityType
        if (capabilityType === 1) {
          params.capabilityAddr = this.xmlFileInfo.fileAddr
        } else {
          params.capabilityAddr = this.capabilityUrl
        }
      } else {
        params.worCRS = this.currMapServiceInfo.worCRS
        params.lodMin = this.currMapServiceInfo.lodMin
        params.lodMax = this.currMapServiceInfo.lodMax
        let {
          projFlatBaseX,
          projFlatBaseY,
          projFlatSizeX,
          projFlatSizeY,
          projFlatRootNumX,
          projFlatRootNumY,
          enableCoverage,
          effectiveCoverageTop,
          effectiveCoverageDown,
          effectiveCoverageLeft,
          effectiveCoverageRight
        } = this.currMapServiceInfo
        params.projFlatBase = `${projFlatBaseX},${projFlatBaseY}`
        params.projFlatSize = `${projFlatSizeX},${projFlatSizeY}`
        params.projFlatRootNum = `${projFlatRootNumX},${projFlatRootNumY}`
        params.enableCoverage = enableCoverage
        params.effectiveCoverageTop = effectiveCoverageTop
        params.effectiveCoverageDown = effectiveCoverageDown
        params.effectiveCoverageLeft = effectiveCoverageLeft
        params.effectiveCoverageRight = effectiveCoverageRight
      }
      return params
    },
    getCapabilityInfo(capabilityType, capabilityAddr) {
      return new Promise(resolve => {
        let params = { capabilityType, capabilityAddr }
        analyzeCapabilityService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            this.capabilityInfo = data

            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getLayerRange(m_lstVVBB) {
      if (m_lstVVBB.length) {
        let m_vLowerCorner = m_lstVVBB[0].m_vLowerCorner
        let m_vUpperCorner = m_lstVVBB[0].m_vUpperCorner
        return JSON.stringify([m_vLowerCorner, m_vUpperCorner])
      } else {
        return ''
      }
    },
    getWebResUrl() {
      let webResUrl = ''
      let { layer, tileSet } = this.serviceForm
      if (layer && tileSet) {
        let layerInfo = this.layerList.find(el => el.m_strIdentifier === layer)

        let { m_strImgResourceURL, m_strDefStyle } = layerInfo
        if (m_strImgResourceURL.includes('tianditu')) {
          webResUrl = m_strImgResourceURL
        } else {
          let strArray = m_strImgResourceURL.split('/{')
          let tileFormat = m_strImgResourceURL.split('}.')[1]

          webResUrl = `${strArray[0]}/${m_strDefStyle}/${tileSet}/{z}/{y}/{x}.${tileFormat}`
        }
      }

      return webResUrl
    },
    toggleLodListVisible() {
      this.isTableVisible = !this.isTableVisible
    },
    getHeaders() {
      let headers = { Authorization: getToken() }
      return headers
    },
    clearServiceForm() {
      this.serviceForm = {
        serviceName: '',
        capabilityType: 2,
        layerResType: '',
        layer: '',
        layerStyle: '',
        layerRange: '',
        fmtStr_Web: '',
        fmtStr_App: '',
        tileSet: '',
        crs: '',
        wellKnownScale: '',
        startPointX: '',
        startPointY: '',
        spaceExtentX: '',
        spaceExtentY: '',
        projFlatRootNumX: '',
        projFlatRootNumY: '',
        tilePixelX: '',
        tilePixelY: '',
        lodDes: ''
      }
      this.capabilityUrl = ''
      this.isUploadFinish = false
      this.uploadParams = {}
      this.xmlFileInfo = {
        fileName: '',
        fileAddr: ''
      }

      this.isAppUrlVisible = false
      this.capabilityInfo = {}
      this.isTableVisible = false
      this.layerList = []
      this.tileSetList = []
      this.lodList = []
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.file-center {
  :deep(.el-form-item__content) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .apabilityLabel {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 150px;
      padding-right: 12px;
      .icon-box {
        margin: 0 5px;
      }
    }
  }
}
.map-service-info {
  width: 49%;
  border-radius: 4px;
  border: 1px solid var(--wmts-newservice-border-color);
  background-color: var(--wmts-newservice-bg-color);

  .header {
    display: flex;
    height: 40px;
    line-height: 40px;
    background: var(--wmts-newservice-header-bg-color);
    color: var(--wmts-newservice-header-color);
    font-size: 14px;
    font-weight: 400;
    .icon {
      font-size: 24px;
      color: var(--base-primary-bgColor);
      margin: 7px;
      margin-right: 8px;
      cursor: pointer;
    }
  }

  .service-form-box {
    max-height: 640px;
    padding: 16px;
    overflow-y: auto;

    :deep(.el-form) {
      .el-form-item {
        margin-bottom: 10px;

        .common-select-box {
          .el-select {
            width: 100%;
          }
        }

        .el-radio {
          color: var(--default-color);
        }
      }
    }

    .layer-info-box {
      margin-bottom: 15px;
      padding: 20px 10px 10px 0px;
      border-radius: 8px;
      background-color: var(--wmts-newservice-layer-bg-color);
      border: 1px solid var(--wmts-newservice-layer-border-color);
      border-radius: 8px;

      .item-box {
        .common-input-box {
          :deep(.is-disabled) {
            .el-input__inner {
              &:hover {
                border-color: var(--base-border-dark-color14) !important;
              }

              &:focus {
                border: 1px solid var(--base-border-dark-color14) !important;
              }
            }
          }
        }
      }

      .label-box {
        .icon-box {
          margin: 0px 5px;
        }
      }

      .url-content-box {
        display: flex;
        flex-grow: 1;

        .common-input-box {
          flex-grow: 1;
        }

        .icon-box {
          font-size: 22px;
          margin-left: 5px;
        }
      }
    }

    .item-box {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .publish-table-container {
        width: 100%;
        :deep(.el-table) {
          background: var(--wmts-newservice-table-bg-color);
          &::before {
            display: none;
          }

          .el-table__header-wrapper {
            .el-table__cell {
              background-color: var(--wmts-newservice-th-bg-color);
              border-color: var(--wmts-newservice-th-border-color);
              padding: 8px 0;
            }
          }
        }

        :deep(.el-table__body-wrapper) {
          .el-table__body {
            margin-top: 2px;
            .el-table__row {
              &:not(:last-child) {
                .el-table__cell {
                  border-bottom: none;
                }
              }
              .el-table__cell {
                background: var(--wmts-newservice-td-bg-color);
                height: 40px;
                line-height: 40px;
                border-top: 1px solid var(--wmts-newservice-td-border-color);
                border-bottom-color: var(--wmts-newservice-td-border-color);
                &:first-child {
                  border-left: 1px solid var(--wmts-newservice-td-border-color);
                }
                &:last-child {
                  border-right: 1px solid var(--wmts-newservice-td-border-color);
                }
              }
            }
          }

          .el-table__empty-block {
            border: 1px solid var(--wmts-newservice-table-empty-border-color);

            &::before {
              content: '';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 1px;
              background-color: var(--wmts-newservice-table-empty-border-color);
            }
          }
        }
      }

      // .publish-table {
      //   :deep(.el-table__header-wrapper) {
      //     border-radius: 0;
      //     .el-table__header {
      //       tr {
      //         background-color: var(--base-bg-dark-color33);
      //       }
      //     }
      //   }
      // }
      .disabled {
        color: var(--wmts-newservice-diiabled-label-color);
      }

      .label-box {
        display: flex;
        justify-content: flex-end;
        flex-shrink: 0;
        width: 150px;
        padding: 0 12px 0 0;
        font-size: 14px;
        line-height: 32px;

        .icon-box {
          display: inline-block;
        }
        .urlModel {
          display: flex;
          align-items: center;
        }
      }

      .symbol-label-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 150px;
        padding: 0 12px 0 0;
        font-size: 14px;
        line-height: 32px;

        .symbol-box {
          width: 4px;
          height: 15px;
          background: var(--base-primary-bgColor);
        }
      }

      .xy-input-box {
        display: flex;
        align-items: center;

        &:last-child {
          margin-left: 10px;
        }
      }

      .view-detail-btn-box {
        display: flex;
        align-items: center;
        margin-left: 10px;
        cursor: pointer;

        .title {
          color: var(--base-primary-bgColor);
          font-size: 14px;
          font-weight: 400;
        }

        .icon-box {
          color: var(--base-primary-bgColor);
          margin-right: 5px;
        }
      }

      .common-table-box {
        flex-grow: 1;
        height: 180px;

        .el-table {
          overflow-y: auto;
        }
      }

      .common-input-box {
        flex-grow: 1;
      }

      .common-select-box {
        flex-grow: 1;
        .el-select {
          width: 100%;
        }
      }

      // .common-button-box {
      //   .el-button {
      //     margin-left: 10px;
      //     margin-right: 0px;
      //   }
      // }
    }
  }
}
</style>
